const pages = {
  slug: 'f/pages',
  getTermsOfUse: () => `${pages.slug}/terms-of-use`,
  getPrivacyNotice: () => `${pages.slug}/privacy-notice`,
  getAboutUs: () => `${pages.slug}/about-us`
}

export default pages
